module.exports = __webpack_public_path__ + "media/images/profit-up-197f1422685dd3a8f423c2c9d29b5640.svg";